import { styled } from 'baseui'

export const TodayCallbacksDrawerOverrides = {
  Root: {
    style: {
      zIndex: 1100,
    },
  },
  DrawerContainer: {
    style: {
      width: '24rem',
      maxWidth: '100vw',
    },
  },
  DrawerBody: {
    style: {
      marginTop: '1.5rem',
      marginBottom: '1.5rem',
      marginLeft: '1.5rem',
      marginRight: '1.5rem',
    },
  },
}

export const ButtonSpacer = styled('div', {
  marginTop: '0.5rem',
})

export const DrawerTitle = styled('h2', ({ $theme }) => ({
  margin: '0 0 1rem',
  fontSize: '1.25rem',
  fontWeight: 600,
  color: $theme.colors.textHeading,
}))

export const StateMessage = styled('p', ({ $theme }) => ({
  margin: '0 0 1rem',
  fontSize: '0.875rem',
  color: $theme.colors.textMuted,
}))

export const CallbackList = styled('ul', {
  margin: 0,
  padding: 0,
  listStyle: 'none',
})
